export default __webpack_public_path__ + "static/media/icon.0ada2d79.svg";